/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SignTinycon16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zm3.75 10.5a.25.25 0 110 .5h-7.5a.25.25 0 010-.5h7.5zM7 4c.968 0 1.596 1.132 1.498 2.292-.07.826-.639 1.813-1.435 2.634l-.055.055.04.062c.179.27.396.43.64.454l.062.003c.197 0 .365-.126.59-.444l.098-.147.175-.272.077-.113.072-.097C8.97 8.16 9.19 8 9.5 8c.337 0 .57.195.734.491.038.07.07.134.101.211l.05.13.16.465.035.095.04.093.055-.015c.122-.04.254-.122.398-.254l.073-.07a.5.5 0 11.708.707c-.42.42-.873.647-1.354.647-.337 0-.57-.195-.734-.492a1.91 1.91 0 01-.101-.21l-.05-.13-.166-.482-.22.341c-.422.633-.838.973-1.479.973-.626 0-1.115-.288-1.474-.78l-.045-.063-.029.022a5.16 5.16 0 01-1.442.764l-.123.038a.5.5 0 01-.274-.962c.46-.131.933-.399 1.368-.738l.064-.051-.016-.05c-.18-.588-.27-1.284-.278-2.04v-.142C5.504 5.098 6.026 4 7 4zm0 1c-.218 0-.497.586-.5 1.502A7.25 7.25 0 006.61 7.82l.019.097.082-.098c.42-.52.714-1.068.781-1.522l.01-.09C7.558 5.556 7.25 5 7.002 5zm2.5 1.5a.5.5 0 110 1 .5.5 0 010-1z"
        />
    </AccessibleSVG>
);

export default SignTinycon16;
